import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  useGetInvoiceHistoryListDataQuery,
  useUpdateInvoiceHistoryTableHeadDataMutation,
} from "../../../store/queries/Billing";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useEffect, useRef, useState } from "react";
import { updateConfig } from "../../../store/slices/Billing/staffBillingSlice";
import { getInvoice, getReceipt } from "../Invoice/api";
import moment from "moment";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";
import { debounce } from "lodash";
import { subDays } from "date-fns";
import { getSupportingDoc } from "../api";
import { useLocation } from "react-router-dom";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const useInvoices = () => {
  const invoiceRef2 = useRef(null);
  const receiptRef2 = useRef(null);
  const supportDocRef = useRef(null);
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    key: "selection",
  });
  const startDate = new Date(date.startDate).toISOString().split("T")[0];
  const endDate = new Date(date.endDate).toISOString().split("T")[0];
  const initialFormattedDate = [startDate, endDate];
  const [formattedDate, setFormattedDate] = useState(initialFormattedDate);
  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];
  const dispatch = useDispatch();
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const queryState = useSelector((state) => state.staffBilling);
  const invoiceState = useSelector(
    (state) => state.staffBilling.invoiceHistoryFilter,
  );
  const { supportPages, totalPages, invoicePages } = queryState;
  const {
    data: queryList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetInvoiceHistoryListDataQuery({
    per_page: queryState.currentPageSize,
    page: queryState.currentPage,
    sort_by: queryState.sortBy,
    sort_order: queryState.sortOrder,
    date: formattedDate,
    search: queryState.search,
  });

  const [updateInvoiceHistoryFields] =
    useUpdateInvoiceHistoryTableHeadDataMutation();

  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        state.tableFields = queryList?.data?.fields;
      }),
    );
    // eslint-disable-next-line
  }, [queryList]);

  useEffect(() => {
    //reset
    dispatch(
      updateConfig((state) => {
        state.invoiceHistoryFilter.selectedId = [];
        state.invoiceHistoryFilter.revertState = false;
        state.currentPage = 1;
      }),
    );
  }, [location]);

  const handleRevert = (id) => {
    dispatch(
      updateConfig((state) => {
        state.invoiceHistoryFilter.showRevertmodal = true;
        state.invoiceHistoryFilter.selectedId = [id];
      }),
    );
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      revert: (_, data) => (
        <p className="pro-mb-0">
          {
            <Button
              className={"pro-btn-primary"}
              onClick={() => handleRevert(data?._id)}
              // onClick={() => handleRemarksClick(data)}
            >
              Revert
            </Button>
          }
        </p>
      ),
    };

    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handleSort = (label) => {
    if (queryState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = queryState.sortOrder === "asc" ? "desc" : "asc";
        }),
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        }),
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      }),
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      }),
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      }),
    );
  };

  const handleSearchDebounced = debounce((value, dispatch) => {
    dispatch(
      updateConfig((state) => {
        state.search = value;
        state.currentPage = 1;
      }),
    );
  }, 1000);

  const handleSearch = (e) => {
    handleSearchDebounced(e.target.value, dispatch);
  };

  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.invoiceModal = !state.invoiceModal;
        state.slectedInvoice = e?.[0];
      }),
    );
    dispatch(updateConfig((state) => (state.invoiceData = "")));
  };

  // const handleInvoiceClick = async (invoiceId) => {
  //   try {
  //     dispatch(updateConfig((state) => (state.clear = true)));

  //     // 1. Fetch invoice first
  //     const invoiceRes = await getInvoice(invoiceId);
  //     if (invoiceRes?.data?.status_code !== 200) {
  //       toast.error("Failed to fetch invoice");
  //       return;
  //     }
  //     dispatch(
  //       updateConfig((state) => {
  //         state.invoicePrintData = invoiceRes?.data?.data;
  //       })
  //     );

  //     // 2. Fetch supporting doc
  //     const supportRes = await getSupportingDoc(invoiceId);
  //     if (supportRes?.data?.status_code !== 200) {
  //       toast.error("Failed to fetch supporting doc");
  //       return;
  //     }
  //     dispatch(
  //       updateConfig((state) => {
  //         state.supportingPrintData = supportRes?.data?.data;
  //       })
  //     );

  //     // Give DOM time to render
  //     await new Promise((r) => setTimeout(r, 500));

  //     // 🔹 3. Render supporting PDF first
  //     const supportPdf = await html2pdf()
  //       .set({
  //         margin: [17, 4, 17, 4],
  //         image: { type: "jpeg", quality: 1 },
  //         html2canvas: { dpi: 100, useCORS: true, scale: 2, scrollY: 0 },
  //         jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //         pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  //       })
  //       .from(supportDocRef.current)
  //       .toPdf()
  //       .get("pdf");

  //     const supportPages = supportPdf.internal.getNumberOfPages();

  //     // Save supporting PDF with numbering
  //     for (let j = 1; j <= supportPages; j++) {
  //       supportPdf.setPage(j);
  //       supportPdf.text(`${j+1} / ${supportPages + 1}`, 180, 285);
  //     }
  //     supportPdf.save(
  //       `Supporting_${moment(Date.now()).format("MM_DD_YYYY_HH_mm_ss")}.pdf`
  //     );

  //     // 🔹 4. Render invoice PDF AFTER knowing supportPages
  //     const invoicePdf = await html2pdf()
  //       .set({
  //         margin: [28, 0, 0, 0],
  //         image: { type: "jpeg", quality: 1 },
  //         html2canvas: { dpi: 100, useCORS: true, scale: 2, scrollY: 0 },
  //         jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //         pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  //       })
  //       .from(invoiceRef2.current)
  //       .toPdf()
  //       .get("pdf");

  //     const invoicePages = invoicePdf.internal.getNumberOfPages();
  //     const totalPages = supportPages + invoicePages;

  //     for (let i = 1; i <= invoicePages; i++) {
  //       invoicePdf.setPage(i);
  //       invoicePdf.text(`1 / ${totalPages}`, 180, 285);
  //     }
  //     invoicePdf.save(
  //       `Invoice_${moment(Date.now()).format("MM_DD_YYYY_HH_mm_ss")}.pdf`
  //     );

  //     dispatch(updateConfig((state) => (state.clear = false)));
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Something went wrong during PDF generation");
  //   }
  // };

  const handleInvoiceClick = async (invoiceId) => {
    try {
      dispatch(updateConfig((state) => (state.clear = true)));

      // 1. Fetch invoice first
      const invoiceRes = await getInvoice(invoiceId);
      if (invoiceRes?.data?.status_code !== 200) {
        toast.error("Failed to fetch invoice");
        return;
      }

      dispatch(
        updateConfig((state) => {
          state.invoicePrintData = invoiceRes?.data?.data;
        }),
      );

      // 2. Fetch supporting doc
      const supportRes = await getSupportingDoc(invoiceId);
      if (supportRes?.data?.status_code !== 200) {
        toast.error("Failed to fetch supporting doc");
        return;
      }

      dispatch(
        updateConfig((state) => {
          state.supportingPrintData = supportRes?.data?.data;
        }),
      );

      // Allow UI to render content
      await new Promise((r) => setTimeout(r, 500));

      // 3️⃣ First: Render supporting doc silently to get page count
      const tempSupportPdf = await html2pdf()
        .set({
          margin: [17, 4, 17, 4],
          html2canvas: { dpi: 100, useCORS: true, scale: 2, scrollY: 0 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(supportDocRef.current)
        .toPdf()
        .get("pdf");

      const supportPages = tempSupportPdf.internal.getNumberOfPages();
      const currentSupportPage =
        tempSupportPdf.internal.getCurrentPageInfo().pageNumber;

      dispatch(
        updateConfig((state) => {
          state.supportPages = supportPages;
          state.invoicePages = 1; // always 1 for invoice
          state.totalPages = supportPages + 1;
          state.currentSupportPage = currentSupportPage;
        }),
      );

      // Wait HTML to update with page numbers inside DOM
      await new Promise((r) => setTimeout(r, 300));

      // 5️⃣ Generate and save SUPPORTING PDF (with page numbers already in DOM)
      await html2pdf()
        .set({
          margin: [17, 4, 17, 4],
          html2canvas: { dpi: 100, useCORS: true, scale: 2, scrollY: 0 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(supportDocRef.current)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const total = pdf.internal.getNumberOfPages(); // supporting only

          for (let i = 1; i <= total; i++) {
            pdf.setPage(i);

            const displayPage = i + 1; // because invoice = page 1

            pdf.setFontSize(10);
            pdf.text(
              `${displayPage} / ${total + 1}`, // full flow: invoice + supporting
              pdf.internal.pageSize.getWidth() - 20,
              pdf.internal.pageSize.getHeight() - 10,
            );
          }
        })
        .save(
          `${invoiceRes?.data?.data?.invoice_number || ""}_Supporting Document_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
        );

      // 6️⃣ Generate and save INVOICE PDF (with page numbers already in DOM)
      await html2pdf()
        .set({
          margin: [28, 0, 0, 0],
          html2canvas: { dpi: 100, useCORS: true, scale: 2, scrollY: 0 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(invoiceRef2.current)
        .save(
          `${invoiceRes?.data?.data?.invoice_number || ""}_Invoice_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
        );

      dispatch(updateConfig((state) => (state.clear = false)));
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong during PDF generation");
    }
  };

  const handleSlipClick = (invoiceId) => {
    getReceipt(invoiceId).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig((state) => {
            state.receiptPrintData = response?.data?.data;
            state.clear = true;
          }),
        );
        setTimeout(() => {
          dispatch(updateConfig((state) => (state.clear = false)));
          const element = receiptRef2?.current;
          html2pdf(element, {
            margin: [28, 0, 0, 0],
            filename: `${response?.data?.data?.receipt_number || ""}_Cash Receipt_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
            image: { type: "jpeg", quality: 1 },
            html2canvas: {
              dpi: 100,
              letterRendering: true,
              useCORS: true,
              logging: true,
              scale: 4,
              scrollY: 0,
            },
            jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
            pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
            DisablePdfCompression: true,
          })
            .from("element-to-print")
            .outputPdf() // add this to replace implicite .save() method, which triggers file download
            .get("pdf")
            .then(function (pdfObj) {
              pdfObj.autoPrint();
              window.open(pdfObj.output("bloburl"), "F");
            });
        }, 500);
      } else {
        toast.error("Something went wrong to print");
      }
    });
  };

  const handleDateChange = (date) => {
    const startDateUTC = new Date(date.startDate);
    const endDateUTC = new Date(date.endDate);
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
    const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);

    const formatDate = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const startDateFormatted = formatDate(startDateIST);
    const endDateFormatted = formatDate(endDateIST);
    const dateArray = [startDateFormatted, endDateFormatted];
    setFormattedDate(dateArray);
    dispatch(
      updateConfig((state) => (state.invoiceHistoryFilter.date = dateArray)),
    );
  };

  const handleSelectedId = (id) => {
    dispatch(
      updateConfig((state) => {
        state.invoiceHistoryFilter.selectedId = id;
        state.invoiceHistoryFilter.revertState = false;
      }),
    );
  };
  const handleRevertModalOpen = () => {
    dispatch(
      updateConfig((state) => {
        state.invoiceHistoryFilter.showRevertmodal = true;
      }),
    );
  };
  const handleRevertModalClose = () => {
    dispatch(
      updateConfig((state) => {
        state.invoiceHistoryFilter.showRevertmodal = false;
      }),
    );
  };

  const cardData = [
    {
      label: "Total GLI",
      value: queryList?.data?.total_count ?? "--",
    },
    {
      label: "Daily Billed Amount",
      value: queryList?.data?.daily_total ?? "--",
    },
    {
      label: "Monthly Billed Amount",
      value: queryList?.data?.monthly_total ?? "--",
    },
    {
      label: "Total Billed Amount",
      value: queryList?.data?.sum_total ?? "--",
    },
  ];
  return {
    queryList,
    paginationOptions,
    isLoading,
    isFetching,
    tableFields,
    queryState,
    showEditModal,
    invoiceRef2,
    receiptRef2,
    date,
    supportDocRef,
    invoiceState,
    updateConfig,
    dispatch,
    handleDateChange,
    handleEditColumnsClick,
    handlePageSize,
    handlePagination,
    getRow,
    refetch,
    handleSort,
    handleSearch,
    handleEditAction,
    handleInvoiceClick,
    handleSlipClick,
    updateInvoiceHistoryFields,
    handleSelectedId,
    handleRevertModalOpen,
    handleRevertModalClose,
    cardData,
    periodicSummaryPermission: queryList?.data?.periodic_summary_permission,
  };
};

export default useInvoices;
